import { FC, ReactNode } from "react";
import { AppKey } from "shared-ts-app-info";
import { SettingsStorage } from "./storage/SettingsStorage";
import { LocalSettingsStorage } from "./storage/LocalSettingsStorage";
import { UnsupportedError } from "shared-ts-utils-core";
import { UserSettingsProviderAsync } from "./UserSettingsProviderAsync";
import { UserSettingsProviderNonAsync } from "./UserSettingsProviderNonAsync";
import { ReadOnlyUserSettings } from "./ReadOnlyUserSettings";

export interface UserSettingsProviderProps {
  appKey?: AppKey;
  storage?: SettingsStorage;
  loadingComponent?: ReactNode;
  children: ReactNode | ((settings: ReadOnlyUserSettings) => ReactNode);
}

export const UserSettingsProvider: FC<UserSettingsProviderProps> = (props) => {
  const storage = props.storage ?? LocalSettingsStorage;

  if (storage.type === "NonAsync") {
    return (
      <UserSettingsProviderNonAsync
        appKey={props.appKey}
        storage={props.storage}
        children={props.children}
      />
    );
  } else if (storage.type === "Async") {
    return (
      <UserSettingsProviderAsync
        appKey={props.appKey}
        storage={props.storage}
        loadingComponent={props.loadingComponent}
        children={props.children}
      />
    );
  } else {
    throw new UnsupportedError(
      "Unsupported SettingsStorage.type: " + storage.type
    );
  }
};
